/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import {
  RecipientOptions,
  TriggerOptions
} from '../../../../../../models/workflowNotificationTrigger.model';
import { ActionType, WorkflowAction } from './workflow-action';

export class SendEmailAction extends WorkflowAction {
  constructor() {
    super(ActionType.SendEmail);
  }

  id?: string;
  trigger_options?: TriggerOptions;
  recipient_options?: RecipientOptions;

  isValid(): boolean {
    const triggers = this.trigger_options?.trigger_types;
    const recipients = this.recipient_options;

    const areTriggersValid: boolean = !!(
      triggers &&
      (triggers.task_closed ||
        triggers.incident_trigger_all ||
        (triggers.incidents && triggers.incidents.length > 0))
    );
    const areRecipientsValid: boolean = !!(
      recipients &&
      (recipients.all_supervisors === true ||
        (recipients.employeegroups && recipients.employeegroups.length > 0) ||
        (recipients.employees && recipients.employees.length > 0) ||
        recipients.executors === true ||
        recipients.trigger_group_supervisors === true)
    );

    return areTriggersValid && areRecipientsValid;
  }
}
